export { default as DeviceConnectionProvider } from "./Provider";
export { Consumer as DeviceConnectionConsumer } from "./Context";
export { default as DisplayOn } from "./DisplayOn";



// WEBPACK FOOTER //
// ./src/components/DeviceConnection/index.js